var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikeThrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42177 4.59526C5.42177 1.88615 8.55563 0.516602 11.9185 0.516602C13.8953 0.516602 15.5345 1.00644 16.6193 1.79618C17.5474 2.44597 18.3791 3.52561 18.3791 5.03512H14.751C14.751 4.72522 14.6908 4.44531 14.5702 4.1854C14.2207 3.32568 13.1238 2.90582 11.8582 2.90582C9.61633 2.90582 9.03777 3.92548 9.03777 4.60526C9.03777 5.0851 9.3391 5.48497 9.92971 5.81486C10.3877 6.06478 10.8578 6.29471 11.6292 6.51463H6.07265C5.81953 6.17475 5.42177 5.62493 5.42177 4.59526ZM22.4772 9.51365V7.51431H0.78125V9.51365H12.3765C13.7627 9.9635 14.739 10.2634 14.739 11.483C14.739 12.4827 13.7627 13.1525 11.9908 13.1525C10.1346 13.1525 8.45921 12.6126 8.45921 10.6433H4.87938C4.87938 11.1931 4.9758 11.7729 5.16865 12.2228C6.14497 14.512 9.13419 15.5217 12.0029 15.5217C14.739 15.5217 18.3911 14.632 18.3911 11.473C18.3911 11.1731 18.3791 10.3134 17.8126 9.53364H22.4772V9.51365Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikeThrough);
export default __webpack_public_path__ + "static/media/strike-through.4c8df01f0e4b278fbadb4913b9afb607.svg";
export { ForwardRef as ReactComponent };